const getStatusColor = (status) => {
    switch (status) {
        case 'Pending Orders' || 'Pending':
            return 'warning';
        case 'Pending':
            return 'warning';
        case 'In Progress':
            return 'info';
        case 'confirmed':
            return 'primary';
        case 'Completed': 
            return 'success'
        case 'Delivered': 
            return 'success'
        case 'Cancelled' || 'Rejected':
            return 'danger'; 
        case 'Rejected':
            return 'danger';       
        default:
            return 'secondary';
    }
};

export default getStatusColor